/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LayoutService } from '../layout.service';
import * as LayoutActions from './layout.actions';
import { Store } from '@ngrx/store';
import { map, tap } from 'rxjs/operators';
import { AppState } from '../../app.reducer';
import { ModalService } from '../../shared/modal.service';
import { LayoutActionTypes, TypeMessage } from './layout.actions';

@Injectable()
export class LayoutEffects {
  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private uiService: LayoutService,
    private modalService: ModalService,
  ) {}

  showMessage = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LayoutActions.ShowMessage),
        tap(action => {
          const { typeMessage, message } = { ...action };
          this.uiService.showMessage(typeMessage, message, 3000);
        }),
      ),
    { dispatch: false },
  );

  showError$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LayoutActions.ShowError),
      map(action => {
        const { message } = { ...action };
        return { type: LayoutActionTypes.ShowMessage, typeMessage: TypeMessage.error, message };
      }),
    ),
  );

  showInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LayoutActions.ShowInfo),
      map(action => {
        const { message } = { ...action };
        return { type: LayoutActionTypes.ShowMessage, typeMessage: TypeMessage.info, message };
      }),
    ),
  );

  showSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LayoutActions.ShowSuccess),
      map(action => {
        const { message } = { ...action };
        return { type: LayoutActionTypes.ShowMessage, typeMessage: TypeMessage.success, message };
      }),
    ),
  );

  showInUseModal$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LayoutActions.ShowInUseModal),
        map(action => this.modalService.open('in-use-message')),
      ),
    { dispatch: false },
  );
}
